import Plotly from "plotly.js-dist-min";

const MIN_CHART_PX = 2;
const FALLBACK_W = 400;
const FALLBACK_H = 360;

export function relayoutPlotlyHostElement(el) {
  if (!el) return;
  if (!el.data && !el.querySelector?.(".js-plotly-plot")) return;

  let w = Math.round(el.clientWidth);
  let h = Math.round(el.clientHeight);
  const parent = el.parentElement;
  if (w < 8 && parent) {
    w = Math.round(parent.clientWidth) || FALLBACK_W;
  }
  if (h < 8) {
    h = Math.round(el.offsetHeight) || FALLBACK_H;
  }
  if (w < 8 && parent?.parentElement) {
    w = Math.round(parent.parentElement.clientWidth) || FALLBACK_W;
  }

  w = Math.max(MIN_CHART_PX, w || FALLBACK_W);
  h = Math.max(MIN_CHART_PX, h || FALLBACK_H);

  try {
    Plotly.relayout(el, { autosize: false, width: w, height: h });
  } catch {
    try {
      Plotly.Plots.resize(el);
    } catch {
      void 0;
    }
  }
}

export function bindPlotlyHostResize(hostEl, scheduleResize) {
  if (!hostEl || typeof scheduleResize !== "function") {
    return () => {};
  }

  const run = () => {
    requestAnimationFrame(() => scheduleResize());
  };

  const cleanupFns = [];

  const observeEl = (node) => {
    if (!node || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(run);
    ro.observe(node);
    cleanupFns.push(() => {
      try {
        ro.disconnect();
      } catch {
        void 0;
      }
    });
  };

  observeEl(hostEl);
  const stack = typeof hostEl.closest === "function" ? hostEl.closest(".qaqc-distribution-chart-stack") : null;
  if (stack && stack !== hostEl) {
    observeEl(stack);
  }

  const vv = typeof window !== "undefined" ? window.visualViewport : null;
  if (vv) {
    const onVv = () => run();
    vv.addEventListener("resize", onVv);
    vv.addEventListener("scroll", onVv);
    cleanupFns.push(() => {
      vv.removeEventListener("resize", onVv);
      vv.removeEventListener("scroll", onVv);
    });
  }

  const onWheel = (e) => {
    if (e.ctrlKey) run();
  };
  const onKey = (e) => {
    if (e.ctrlKey && (e.key === "+" || e.key === "-" || e.key === "=" || e.key === "_")) run();
  };
  if (typeof window !== "undefined") {
    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("keydown", onKey);
    cleanupFns.push(() => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKey);
    });
  }

  return () => {
    cleanupFns.forEach((fn) => {
      try {
        fn();
      } catch {
        void 0;
      }
    });
  };
}
